<template>
    <div style="width: 1200px;margin: auto;">
        <iframe 
             
            :src="FileUrl" 
            height="1800px" width="100%" frameborder="0"></iframe>
    </div>
</template>

<script>
export default{
    data(){
        return{
            FileUrl: ''
        }
    },
    mounted() {
        this.FileUrl = this.$route.query.id
    }
}
</script>